"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlePagination = void 0;
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var pagination_constants_1 = require("./pagination.constants");
var addListItem = function (pageList, onChange, type, page, selected, disabled, isChangeAllowed, id, eventCallback) {
    if (isChangeAllowed === void 0) { isChangeAllowed = true; }
    pageList.push({
        type: type,
        page: page,
        selected: selected,
        disabled: disabled,
        onClick: function () {
            if (isChangeAllowed) {
                eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.PAGINATION_CLICK, { id: id, value: page, type: pagination_constants_1.PAGE_TYPES[type] });
                onChange(page);
            }
        },
    });
};
var handlePagination = function (_a) {
    var count = _a.count, currentPage = _a.currentPage, onChange = _a.onChange, id = _a.id, eventCallback = _a.eventCallback;
    var pageList = [];
    addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.PREV, currentPage - 1, false, currentPage == 1, currentPage > 1, id, eventCallback);
    /* if the current seelcted page is from 1 to 4, it will show 1 to 5 pages in list
     * else 1st page with appended start ellipsis
     * eg 1 2 [3] 4 5 ... 10
     */
    if (currentPage < 5) {
        for (var i = 1; i <= 5 && i <= count; i++)
            addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.PAGE, i, i === currentPage, false, true, id, eventCallback);
    }
    else {
        addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.PAGE, 1, false, false, true, id, eventCallback);
        addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.START_ELLIPSIS, 0, false, true, true, id, eventCallback);
    }
    if (count > 5) {
        /* if the current selected page is is between +4 ~ -4 of total pages,
         * it will show selected page at center with next and prev page of the current page
         * eg 1 ... 4 [5] 6 ... 10
         */
        if (currentPage > 4 && currentPage <= count - 4)
            for (var i = currentPage - 1; i <= currentPage + 1; i++)
                addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.PAGE, i, i === currentPage, false, true, id, eventCallback);
        /* if the current selected page is from total count-4 to total count, it will show last 5 pages in list
         * else last page with  end ellipsis
         * eg 1 ... 7 8 [9] 10
         */
        if (currentPage <= count - 4 || currentPage <= 4) {
            /* Default ellipsis will be there after 5, no ellipsis will show if total count is 6
             * else last page with  end ellipsis
             * eg 1 2 3 [4] 5 6
             */
            if (count > 6)
                addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.END_ELLIPSIS, 0, false, true, true, id, eventCallback);
            addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.PAGE, count, false, false, true, id, eventCallback);
        }
        else {
            for (var i = count - 4; i <= count; i++)
                addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.PAGE, i, i === currentPage, false, true, id, eventCallback);
        }
    }
    addListItem(pageList, onChange, pagination_constants_1.PAGE_TYPES.NEXT, currentPage + 1, false, currentPage == count, currentPage < count, id, eventCallback);
    return { items: pageList };
};
exports.handlePagination = handlePagination;
